/**
 * Color palette — Horizon Travel
 * Direction: deep ink + cool mist + sea teal (calm, premium, not Umrah-blue clone)
 */

export const colors = {
  primary: {
    main: '#0E1C2A',
    light: '#1A3348',
    dark: '#071018',
    50: '#E8EEF2',
    100: '#C5D3DE',
    200: '#9BB3C5',
    300: '#6F92AB',
    400: '#4A738F',
    500: '#2F5570',
    600: '#1A3348',
    700: '#0E1C2A',
    800: '#0A1520',
    900: '#071018',
  },

  secondary: {
    main: '#1F6F78',
    light: '#2A8F9A',
    dark: '#16555C',
  },

  accent: {
    main: '#C4A574',
    light: '#D4BC94',
    dark: '#A88855',
  },

  success: {
    main: '#2E7D4F',
    light: '#4CAF70',
    dark: '#1B5E35',
  },

  warning: {
    main: '#C47B2B',
    light: '#D49A55',
    dark: '#9A5E1C',
  },

  error: {
    main: '#B33A3A',
    light: '#D45A5A',
    dark: '#8C2A2A',
  },

  info: {
    main: '#1F6F78',
    light: '#2A8F9A',
    dark: '#16555C',
  },

  neutral: {
    white: '#FFFFFF',
    black: '#0A0A0A',
    50: '#F7F8FA',
    100: '#EEF1F4',
    200: '#E2E6EB',
    300: '#C8CED6',
    400: '#9AA3AE',
    500: '#6B7380',
    600: '#4A5160',
    700: '#2F3540',
    800: '#1A1F27',
    900: '#0E1218',
  },

  background: {
    default: '#F7F8FA',
    paper: '#FFFFFF',
    light: '#EEF1F4',
    lighter: '#E8ECF0',
    ink: '#0E1C2A',
  },

  text: {
    primary: '#0E1C2A',
    secondary: '#5A6570',
    disabled: '#9AA3AE',
    hint: '#6B7380',
    inverse: '#F7F8FA',
  },

  gradient: {
    primary: 'linear-gradient(145deg, #0E1C2A 0%, #1A3348 55%, #1F6F78 100%)',
    secondary: 'linear-gradient(135deg, #1F6F78 0%, #2A8F9A 100%)',
    // Light photo-forward hero (destination stays visible)
    hero:
      'linear-gradient(105deg, rgba(247, 248, 250, 0.94) 0%, rgba(247, 248, 250, 0.72) 38%, rgba(247, 248, 250, 0.25) 68%, rgba(247, 248, 250, 0.08) 100%)',
    mist: 'linear-gradient(180deg, #F7F8FA 0%, #EEF1F4 100%)',
  },

  border: {
    light: '#E2E6EB',
    main: '#C8CED6',
    dark: '#6B7380',
  },
};

export default colors;
